import defaultStyled from '../../styled-components.mjs';
import { flex_container, flex_direction } from '../../styles/flexprefix.mjs';
import { content_max_width_mobile, breakpoint_tablet, breakpoint_desktopS } from '../../styles/variables.mjs';
import { absoluteXV } from '../../styles/mixins.mjs';
import { button_reset } from '../../styles/placeholders.mjs';

const HalfLayerWrapperStyle = defaultStyled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${props => props.zIndex ? props.zIndex : 2000};

    &.hide {
        transition-delay: 0.3s;
        transform: translateY(100%);
    }
    &.hide-no-animation {
        display: none;
    }

    .halflayer-inner {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background-color: #fff;
        box-sizing: border-box;
        letter-spacing: -0.5px;
        text-align: center;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        transition: all 0.3s cubic-bezier(0.33, 0, 0.2, 1);
        @supports (padding-bottom: constant(safe-area-inset-bottom)) {
            padding-bottom: constant(safe-area-inset-bottom);
        }
        @supports (padding-bottom: env(safe-area-inset-bottom)) {
            padding-bottom: env(safe-area-inset-bottom);
        }
        &.scroll {
            overflow: auto;
        }

        &.enter {
            transform: translate3d(0, 0%, 0);
        }

        &.leave {
            transform: translate3d(0, 100%, 0);
        }
    }

    .button-close {
        ${button_reset}

        position: absolute;
        right: 0;
        top: 0;
        padding: 18px;
        svg {
            display: block;
            margin: 1px 0 0;
        }
    }

    &.type_filter {
        .halflayer-inner {
            max-height: 100%;
            overflow-y: auto;
            overflow-x: visible;
            -webkit-overflow-scrolling: touch;
        }
    }

    /// 웹뷰 아이폰 Xs Max 기준 가로모드( 태블릿 이하 )
    /// 갤럭시 노트 10+ = 412px / 아이폰XsMax = 414px
    @media screen and (max-height: 414px) and (orientation: landscape) {
        .halflayer-inner {
            height: 100%;
        }
    }

    &.dark-type {
        .button-close svg g {
            fill: #fff;
        }
    }
    // inner 위로 메시지가 노출되는 형태
    &.message-type .halflayer-inner {
        overflow: visible;
    }

    // inner 좌우 여백이 있는 경우
    &.notfull-type .halflayer-inner {
        left: 14px;
        right: 14px;
        @media screen and (max-width: 320px) {
            left: 20px;
            right: 20px;
        }
    }
    // 레이어의 배경색이 #fff가 아닌 경우
    // Radius값이 있는 좌·우 상단으로 #fff 배경색이 비치는 이슈로 배경색 제거
    &.no-background .halflayer-inner {
        background-color: transparent;
    }

    &.limit-width-big .halflayer-inner,
    &.limit-width .halflayer-inner {
        height: auto;
        max-height: 100%;
        width: 100%;
        margin: 0 auto;
    }

    &.limit-width .halflayer-inner {
        max-width: 540px;
    }

    &.limit-width-big .halflayer-inner {
        ${flex_container};
        ${flex_direction('column')}

        max-width: ${content_max_width_mobile};
    }
    @media (min-width: ${breakpoint_tablet}) {
        .halflayer-inner {
            max-width: ${content_max_width_mobile};
            margin: 0 auto;
        }
    }
    @media (min-width: ${breakpoint_desktopS}) {
        .halflayer-wrapper {
            ${absoluteXV}
            z-index: 10;
            width: ${content_max_width_mobile};
            border-radius: 16px;
            overflow: hidden;
            .halflayer-inner {
                position: static;
                border-radius: 0;
                max-width: 100%;
                margin: 0;
            }
        }
    }
`;

export { HalfLayerWrapperStyle };
